export type ColumnConfig = {
  orderedKeys: string[];
  hiddenKeys: string[];
};

export const reconcileColumnKeys = (savedKeys: string[], allKeys: string[]): string[] => {
  const allKeySet = new Set(allKeys);
  const savedKeySet = new Set(savedKeys);
  const validSaved = savedKeys.filter((k) => allKeySet.has(k));
  let savedIdx = 0;
  const result: string[] = [];
  for (const key of allKeys) {
    if (!savedKeySet.has(key)) {
      result.push(key);
    } else if (savedIdx < validSaved.length) {
      result.push(validSaved[savedIdx++]);
    }
  }
  return result;
};

export const loadStoredConfig = (storageKey: string): ColumnConfig => {
  try {
    const saved = localStorage.getItem(storageKey);
    if (!saved) return { orderedKeys: [], hiddenKeys: [] };
    const parsed = JSON.parse(saved);
    return {
      orderedKeys: Array.isArray(parsed.orderedKeys) ? parsed.orderedKeys : [],
      hiddenKeys: Array.isArray(parsed.hiddenKeys) ? parsed.hiddenKeys : [],
    };
  } catch {
    return { orderedKeys: [], hiddenKeys: [] };
  }
};
